module.exports = __webpack_public_path__ + "static/img/3.75507e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/zh/3.png
// module id = RLwr
// module chunks = 0